var map = {
	"./ai-icon.png": 41286,
	"./autoplay/pause.svg": 54370,
	"./autoplay/playBackward.svg": 19153,
	"./autoplay/playForward.svg": 71609,
	"./backArrow.svg": 55622,
	"./bgImage.png": 53918,
	"./buttonsSvg/rocket.svg": 91208,
	"./buttonsSvg/trainingMode.svg": 18423,
	"./buttonsSvg/userCircle.svg": 89201,
	"./chartType/bar-trend.svg": 23262,
	"./chartType/bar.svg": 52532,
	"./chartType/candle.svg": 53938,
	"./chartType/compare.svg": 89574,
	"./chartType/heiken-ashi.svg": 6135,
	"./chartType/kagi.svg": 24301,
	"./chartType/line-data.svg": 81628,
	"./chartType/point-figure.svg": 90962,
	"./chartType/up-down.svg": 61347,
	"./chartType1/bar.svg": 15829,
	"./chartType1/candlestick.svg": 93511,
	"./chartType1/compare.svg": 21695,
	"./chartType1/heikenAshi.svg": 28795,
	"./chartType1/kagi.svg": 51734,
	"./chartType1/line.svg": 16436,
	"./chartType1/point-figure.svg": 96949,
	"./chartType1/trend.svg": 87507,
	"./chartType1/updown.svg": 29117,
	"./closeEye.svg": 11013,
	"./codeSvg.svg": 76145,
	"./descriptionBox/big-candle.png": 71922,
	"./descriptionBox/bollinger-squeeze.png": 69369,
	"./descriptionBox/capitulation.png": 59965,
	"./descriptionBox/darvas-box.png": 72787,
	"./descriptionBox/divergence.png": 98556,
	"./descriptionBox/franks.png": 69417,
	"./descriptionBox/heiken-ashi.png": 35128,
	"./descriptionBox/hhhl.png": 54378,
	"./descriptionBox/indicator-desc.png": 68489,
	"./descriptionBox/pocket-pivot.png": 81879,
	"./descriptionBox/sams-darvas.png": 40848,
	"./dropdownArrow.svg": 37848,
	"./email.svg": 24426,
	"./grayCode.svg": 12072,
	"./handler.svg": 12038,
	"./layouts/layout_1tab.svg": 51185,
	"./layouts/layout_2tab_1.svg": 70848,
	"./layouts/layout_2tab_2.svg": 31859,
	"./layouts/layout_3tab_1.svg": 24627,
	"./layouts/layout_3tab_2.svg": 3872,
	"./layouts/layout_3tab_3.svg": 39825,
	"./layouts/layout_4tab.svg": 19310,
	"./layouts/save.svg": 2129,
	"./login.svg": 85045,
	"./logo.svg": 63935,
	"./openEye.svg": 35945,
	"./phone.svg": 8382,
	"./phoneGray.svg": 46075,
	"./phoneRed.svg": 76843,
	"./redCode.svg": 69176,
	"./redEmail.svg": 20065,
	"./redEye.svg": 98954,
	"./reddropdownArrow.svg": 32575,
	"./rightArrow.svg": 58195,
	"./toolSettings/ArrowLine.svg": 85359,
	"./toolSettings/DashedLine.svg": 94235,
	"./toolSettings/DottedLine.svg": 76004,
	"./toolSettings/SolidLine.svg": 51165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;